import { Button } from "@replicate/ui"
import { Link } from 'react-router-dom'
import PredictionCreateDefaultBash from "./snippets/predictions.create.default/bash.mdx"
import PredictionCreateStreamBash from "./snippets/predictions.create.stream/bash.mdx"

Use one of our client libraries to get started quickly.

<ClientLibraryPicker />

Set the `REPLICATE_API_TOKEN` environment variable

<div className="not-prose">
  <AuthToken showDescription={false} token={props.token} type="shell" />
</div>

<Link to="/learn-more#authentication">
  Learn more about authentication
</Link>

Run **{props.runnableName}** using Replicate’s API. Check out the model's <Link to="/schema">schema</Link> for an overview of inputs and outputs.

{props.streaming === "none" ? (
  <PredictionCreateDefaultBash {...props} />
) : (
  <PredictionCreateStreamBash {...props} />
)}

<Link className="r8-btn r8-btn--filled r8-btn--primary r8-btn--md mt-8" to="/learn-more">Learn more</Link>
